//視聴機能
class YoutubePlayer extends HTMLElement {
  constructor() {
    super();
    //trackInfomation
    this.player;
    this.querySelector('#youtubePlayerClose').addEventListener('click', this.close.bind(this));
  }
  connectedCallback() {
    if (!this.rendered) {
      this.rendered = true;
    }
  }
  static get observedAttributes() {
    return ["youtube-id"];
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if(name === "youtube-id" && newValue ){
      if(this.player){
          this.close();
      }
      this.init(newValue);
    }
  }
  init(id){
    this.classList.add("on")
    this.player = new YT.Player('youtubePlayerIframe', {
        height: '150',
        width: '320',
        videoId:id,
        events: {
          'onReady': this.onPlayerReady,
        }
    });
  }
  close(){
      this.classList.remove("on")
      this.player.destroy()
  }
  onPlayerReady(event){
    event.target.playVideo();
  }
}
customElements.define('youtube-player', YoutubePlayer);